import { render, staticRenderFns } from "./PartnerAcceptanceForm.vue?vue&type=template&id=2c42cfa1"
import script from "./PartnerAcceptanceForm.vue?vue&type=script&lang=js"
export * from "./PartnerAcceptanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports